import { render, staticRenderFns } from "./consolidation.vue?vue&type=template&id=3f3565e4&"
import script from "./consolidation.vue?vue&type=script&lang=js&"
export * from "./consolidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports